<template>
  <v-main>
    <drawer />
    <parking />
  </v-main>
</template>

<script>
import Parking from '@/components/parking'
import Drawer from '@/components/parking/drawer'

export default {
  name: 'view-parking',
  components: { Parking, Drawer }
}
</script>

<style scoped>
</style>
